import { render } from "./OTab.vue?vue&type=template&id=1f8d03ab&scoped=true"
import script from "./OTab.vue?vue&type=script&lang=js"
export * from "./OTab.vue?vue&type=script&lang=js"

import "./OTab.vue?vue&type=style&index=0&id=1f8d03ab&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8d03ab"]])

export default __exports__